export default __webpack_public_path__ + "static/media/step3.d5db994a.webp";